// Core Imports
import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'

// Module Imports
import { dashboardEndpoints } from '@/modules/dashboard/dashboard.constants'
import type {
  TDashboardOverview,
  TDashboardStats,
  TOnlinePlayers,
} from '@/modules/dashboard/dashboard.types'

export async function getDashboardStats(): Promise<TDashboardStats> {
  const response = await api.get<TResponse<TDashboardStats>>(
    dashboardEndpoints.count
  )
  return response.data.data
}

export async function getDashboardOverview(): Promise<TDashboardOverview> {
  const response = await api.get<TResponse<TDashboardOverview>>(
    dashboardEndpoints.overview
  )
  return response.data.data
}

export async function getOnlinePlayers(): Promise<TOnlinePlayers> {
  const response = await api.get<TResponse<TOnlinePlayers>>(
    dashboardEndpoints.onlinePlayers
  )
  return response.data.data
}
